import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux';
import { getOrderCount ,logOut} from '../redux/actions/user';
import { useHistory, Link, NavLink } from 'react-router-dom';
import { totalCartCountSelector } from '../redux/reducers/cart';
import { isDigitalMenu, getText, merchantId } from '../common/Functions';
import {callWaiter,waiterCalled} from '../redux/actions/table';
import {getData} from '../redux/actions/restaurant';
import CallAssistance from '../common/CallAssistance';



function Header({ currentOrderCount, previousOrderCount, getOrderCount, totalItems, token,logOut,callWaiter,getData,restaurant_name,
    waiterCalled,isWaiterCalledInfo,logo}) {
    const [showUserTab, setShowUserTab] = useState(false);  
    const [callwaiter, setCallWaiter] = useState(false); 
    const [callwaiterinfo,setCallwaiterInfo] = useState(true);
    const history = useHistory();

    const checkout = () => {
        if (token) {
            history.push("/checkout");
        } else {
            history.push("/login");
        }
    }

    const redirect = () => {
        history.push("/currentorder");
    }

    const callWaiterFn = () => {
        callWaiter();     
        setCallWaiter(true);   
    }

    useEffect(() => {
        getOrderCount();
        getData();
        }, [])

        const closeCallback = useCallback(
            () => {
                setCallWaiter(false);
            },
            [callwaiter],
          );





    return (
        
            <div className="container">
                <div className="header-top">
                    <div className="header-top-left">
                        <span className="back"><img src="images/arrow-back.png" alt="" /></span>
                    </div>
                    <div className="header-top-mid">
                    {[1451,1405,1664,1667,1671,1672].includes(merchantId) && <span class="resturant-name font-semibold"><img src={logo} alt="" /></span>}                    
                    {![1451,1405,1664,1667,1671,1672].includes(merchantId) && <span className="resturant-name font-semibold">{restaurant_name}</span>}
                    </div>

                    {!isDigitalMenu && <div className="header-top-right">
                    <div className="header-assistance" >
                        <img className="img-dark" src="images/support.png" alt="support" onClick={callWaiterFn} />
                        <img className="img-white" src="images/support-white.png" alt="support" />
                        {!isWaiterCalledInfo && <div className="assistance-message">
                           <h3>Call Staff</h3>
                            <p>Please click here to call for assistance</p>
                            <button class="btn" onClick={waiterCalled}>Got It</button>
                        </div>}
                    </div>
                        <div className={"header-user " + (showUserTab ? " active" : "")} onClick={() => setShowUserTab(!showUserTab)}>
                            <img className="img-dark" src="images/open-menu.png" alt="user" />
                            <img className="img-white" src="images/open-menu-white.png" alt="" />
                            <div className="user-orders-info">
                                <ul>
                               
                                    {token && <><li className="has-sub-menu"><span className="fa fa-file-text-o"></span><a>Your
                                        Orders</a>
                                        <ul>
                                            <li>
                                                <span className="fa fa-repeat"></span>
                                                <Link to="/orders"> Previous Orders
    <span className="order-count">{previousOrderCount}</span></Link>
                                            </li>
                                            {currentOrderCount > 0 && <li>
                                                <span className="fa fa-clock-o"></span>
                                                <a onClick={redirect}>Current Orders
                                                   
    <span className="order-count">{currentOrderCount}</span></a>
                                            </li>}
                                        </ul>
                                    </li>                               
                                    
                                    </>}
                                    <li><span className="fa fa-user-o"></span><Link to="about">About Us</Link></li>
                                    <li><span className="fa fa-user-o"></span><Link to="privacy-policy">Privacy Policy</Link></li>
                                    {!token && <li><span className="fa fa-sign-in"></span><Link to="/login">Login</Link></li>}
                                    {token && <li><span className="fa fa-sign-out"></span><a onClick={() => logOut()}>Logout</a></li>}
                                </ul>
                            </div>
                        </div>
                        <span className="header-cart"  onClick={checkout}><img className="img-dark" src="images/shopping-cart.png" alt="cart" />
                            <img className="img-white" src="images/shopping-cart-white.png" alt="" /></span>
                    </div>}
                    {isDigitalMenu && <div className="header-top-right"></div>}
                </div>
              {callwaiter && <CallAssistance closeCallback={closeCallback} /> }  
            </div>
       
    )
}

const mapStateToProps = (state) => ({
    currentOrderCount: state.user.currentOrderCount,
    previousOrderCount: state.user.previousOrderCount,
    totalItems: totalCartCountSelector(state),
    token: state.user.token,
    restaurant_name:state.restaurant.details?.restaurant_name,
    isWaiterCalledInfo:state.table.waiterCalled,
    logo: state.restaurant.details?.logo
})

export default connect(mapStateToProps, { getOrderCount,logOut,callWaiter,getData,waiterCalled })(Header)
